/// <reference path="../../typings/browser.d.ts" />
/// <reference path="../../customtypings/window.d.ts" />

/**
 * ConnectionRoomGroupService
 */

namespace Application.Services {
    'use strict';

    import ConnectionRoomGroup = Models.ConnectionRoomGroup;
    import HalConverter = Models.HalConverter;
    import IConnectionRoomGroup = Models.IConnectionRoomGroup;
    import IHalElement = Models.IHalElement;
    import IHalList = Models.IHalList;

    /**
     * ConnectionRoomGroupService
     */
    export class ConnectionRoomGroupService {
        public static $name: string = "connectionRoomGroupService";
        public static $inject: string[] = ['$http', '$q', 'networkNodeService', 'backendService', '$rootScope'];

        private http: ng.IHttpService;
        private qService: ng.IQService;
        private networkNodeService: NetworkNodeService;
        private backendService: BackendService;
        private $rootScope: IFlexRootScope;

        private backendBaseUrl: string = window.backendUrl;
        private servicePath: string = '';
        private backendUrl: string = this.backendBaseUrl + this.servicePath + 'connRooms';
        private groupBackendUrl: string = this.backendUrl + '/group';

        constructor($http: ng.IHttpService, $q: ng.IQService, networkNodeService: NetworkNodeService,
                backendService: BackendService, $rootScope: IFlexRootScope) {
            this.http = $http;
            this.qService = $q;
            this.networkNodeService = networkNodeService;
            this.backendService = backendService;

            this.$rootScope = $rootScope;
        }

        /**
         * Creates a new ConnectionRoomGroup or updates an existing one. Persists the changes in the backend
         *
         * @param connectionRoomGroup ConnectionRoomGroup to be created/updated
         * @return created/updated ConnectionRoomGroup
         */
        public saveConnectionRoomGroup(connectionRoomGroup: IConnectionRoomGroup): ng.IPromise<IConnectionRoomGroup> {
            if (!connectionRoomGroup.id ) {
                return this.createConnectionRoomGroup(connectionRoomGroup);
            } else {
                return this.updateConnectionRoomGroup(connectionRoomGroup);
            }
        }

        /**
         * Deletes a ConnectionRoomGroup. Persists the changes in the backend
         *
         * @param id id of the ConnectionRoomGroup
         * @return boolean with the result of the operation
         */
        public deleteConnectionRoomGroup(id: number): ng.IPromise<boolean> {
            return this.backendService.delete(`${this.groupBackendUrl}/${id}`);
        }

        /**
         * Fetch a ConnectionRoomGroup from the backend whose id matches the parameter received.
         *
         * @param id id of the ConnectionRoomGroup
         * @return ConnectionRoomGroup found (if exists)
         */
        public findConnectionRoomGroupById(id: number): ng.IPromise<IConnectionRoomGroup> {
            let url: string = this.groupBackendUrl.concat("/" + id);
            return this.search(url);
        }

        /**
         * Gets a list of ConnectionRoomGroup from the backend that have the connectionRoomId received.
         *
         * @param connectionRoomId id of the room
         * @return list of ConnectionRoomGroup found (if exists)
         */
        public findConnectionRoomGroupByRoomId(connectionRoomId: number): ng.IPromise<IConnectionRoomGroup[]> {
            let url: string = this.backendUrl
                .concat("/" + connectionRoomId)
                .concat("/groups");
            return this.search(url);
        }

        private createConnectionRoomGroup(connectionRoomGroup: IConnectionRoomGroup): ng.IPromise<IConnectionRoomGroup> {
            return this.backendService
                 .post(this.groupBackendUrl, {
                     name: connectionRoomGroup.name,
                     connectionRoomId: connectionRoomGroup.connectionRoomId,
                     connectionRoomGroupBlocks: connectionRoomGroup.connectionRoomGroupBlocks
                 })
               .then((result: ng.IHttpPromiseCallbackArg<ConnectionRoomGroup>) => {
                   return result.data;
               }).catch((reason) => {
                  return ConnectionRoomGroup.Empty();
               });
        }

        private updateConnectionRoomGroup(connectionRoomGroup: IConnectionRoomGroup): ng.IPromise<IConnectionRoomGroup> {
            let connectionRoomGroupUrl: string = this.groupBackendUrl.concat("/" + connectionRoomGroup.id);
            return this.backendService
                .put(connectionRoomGroupUrl, {
                    name: connectionRoomGroup.name,
                    connectionRoomId: connectionRoomGroup.connectionRoomId,
                    connectionRoomGroupBlocks: connectionRoomGroup.connectionRoomGroupBlocks
                })
                .then((result: ng.IHttpPromiseCallbackArg<ConnectionRoomGroup>) => {
                        return result.data;
                    }
                ).catch((reason) => {
                  return ConnectionRoomGroup.Empty();
                });
        }

        private search(url: string): ng.IPromise<ConnectionRoomGroup[]> {
            return this.http.get(url)
                .then((result: ng.IHttpPromiseCallbackArg<ConnectionRoomGroup[]>) => {
                    return result.data;
                }).catch((reason) => {
                  return [];
                });
        }
    }
}
